import React, { useState } from "react";
import Box from "@mui/material/Box";
import ImagesSlider from "./ImagesSlider";
import { sortImages } from "../../../utils/images";

export default function ImagesOutbound({ asset }) {
  const list = sortImages(asset?.images);
  const defaultIndex = list.findIndex(v => v.default);
  const [index, setIndex] = useState(defaultIndex === -1 ? 0 : defaultIndex);

  return (
    <Box
      position="relative"
      sx={{
        width: { xs: "90%", sm: "50%", md: "100%" },
        margin: "0 auto",
      }}
    >
      {list.length === 0 && <Box />}
      <ImagesSlider list={list} index={index} onChangeIndex={setIndex} />
    </Box>
  );
}

